namespace Areas.Submittal.Tracking {
    "use strict";

    let currentSubmittalTracking: any;
    let currentSubmittalItem: any;
   

    export function onNewSubmittalTrackingRow(e: any) {
        e.data.accountId = e.component.option("AccountId");
        e.data.submittalTrackingProfileId = e.component.option("SubmittalTrackingProfileId");
        currentSubmittalItem = e.data;

    }

    export function onNewSubmittalTrackingInserted(e: any) {
        currentSubmittalItem = null;
    }

    export function updateSubmittalItem() {
        const grid = $("#SubmittalGrid").dxForm("instance");
        const newData: any = grid.option("gridData");
        const result: any = grid.validate();
        const keyId: any = grid.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Submittal/Tracking/UpdateSubmittalTracking/${keyId}`, JSON.stringify(newData), "PUT");
        }

    }

    export function addGridButtons(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        let isVisible = grid.option("IsEditable");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "addRevision" },
            text: "Revision",
            hint: "Add Revision",
            type: "default",
            icon: "add",
            visible: isVisible,
            onClick: createSubmittalRevision
        }, "before");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "addSentTo" },
            text: "Sent To",
            hint: "Transmittal Sent To",
            type: "default",
            icon: "add",
            visible: isVisible,
            onClick: createTransmittalSentTo
        }, "before");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "addForwardTo" },
            text: "Forward To",
            hint: "Transmittal Forward To",
            type: "default",
            icon: "add",
            visible: isVisible,
            onClick: createTransmittalForwardTo
        }, "before");

    }

    export function addProfileGridButtons(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        let disabledButton = grid.option("IsEditable");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "import" },
            text: "Import",
            hint: "Import Submittal",
            type: "default",
            icon: "add",
            disabled: disabledButton,
            //onClick: importProfileRecord()
        }, "before");

    }

    export function selectAccount() {
        const accountDialog = new Areas.Dialogs.AccountDialog(dialogClosing);
    }

    export function selectContract() {
        const contractDialog = new Areas.Dialogs.ContractDialog(dialogContractClosing);
    }

    export function selectContact() {
        const dataGrid = $("#SubmittalProfileGrid").dxDataGrid("instance");
        const accountId = dataGrid.option("AccountId");
        const parameters = { accountId: accountId };
        const accountTeamContactLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(
                dialogAccountTeamContactClosing, parameters);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#SubmittalProfileGrid").dxDataGrid("instance");

        var rowIndex = getRowIndex(dataGrid);
        updateGridRow(dataGrid, rowIndex, data);
    }

    function dialogContractClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#SubmittalProfileGrid").dxDataGrid("instance");

        var rowIndex = getRowIndex(dataGrid);
        updateContractGridRow(dataGrid, rowIndex, data);
    }

    function dialogAccountTeamContactClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#SubmittalGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateContactGridRow(dataGrid, rowIndex, data);
    }

    function getRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentSubmittalTracking === undefined || currentSubmittalTracking === null) {
            return rowIndex;
        } else if (currentSubmittalTracking.submittalTrackingProfileId) {
            rowIndex = dataGrid.getRowIndexByKey(currentSubmittalTracking.submittalTrackingProfileId);
        }

        return rowIndex;
    }

    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentSubmittalItem === undefined || currentSubmittalItem === null) {
            return rowIndex;
        } else if (currentSubmittalItem.submittalTrackingId) {
            rowIndex = dataGrid.getRowIndexByKey(currentSubmittalItem.submittalTrackingId);
        }

        return rowIndex;
    }

    function updateGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "accountId", data.accountId);
        dataGrid.cellValue(rowIndex, "accountName", data.accountName);

        currentSubmittalTracking.accountId = data.accountId;
        currentSubmittalTracking.accountName = data.accountName;

        dataGrid.option("AccountId", data.accountId);

        dataGrid.repaintRows([rowIndex]);
    }

    function updateContractGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "contractId", data.contractId);
        dataGrid.cellValue(rowIndex, "contractName", data.contractName);

        currentSubmittalTracking.contractId = data.contractId;
        currentSubmittalTracking.contractName = data.contractName;

        dataGrid.repaintRows([rowIndex]);
    }

    function updateContactGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "assignedToContactId", data.contactId);
        dataGrid.cellValue(rowIndex, "displayName", data.displayName);

        currentSubmittalItem.assignedToContactId = data.contactId;
        currentSubmittalItem.displayName = data.displayName;

        dataGrid.repaintRows([rowIndex]);
    }

    export function onEditingStart(e: any) {
        currentSubmittalTracking = e.data;
    }

    export function onEditingItemStart(e: any) {
        currentSubmittalItem = e.data;
    }

    export function editAccountTemplate(cellElement, cellInfo) {
        let accountDisplayName = !cellInfo.data.accountName ? "Select..." : cellInfo.data.accountName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${accountDisplayName}</div><div class="dx-lookup-arrow" id="account-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectAccount);
        cellElement.append(html);
    }

    export function editContractTemplate(cellElement, cellInfo) {
        let contractDisplayName = !cellInfo.data.contractName ? "Select..." : cellInfo.data.contractName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${contractDisplayName}</div><div class="dx-lookup-arrow" id="contract-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectContract);
        cellElement.append(html);
    }

    export function editContactTemplate(cellElement, cellInfo) {
        let contactDisplayName = !cellInfo.data.displayName ? "Select..." : cellInfo.data.displayName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${contactDisplayName}</div><div class="dx-lookup-arrow" id="contact-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectContact);
        cellElement.append(html);
    }

    export function returnToListFromTab() {
        var linkInfo = "/Submittal/List/Active";
        location.href = linkInfo;

    }

    function createSubmittalRevision() {
        const dataGrid = $("#SubmittalGrid").dxDataGrid("instance");

        if (dataGrid.getSelectedRowKeys().length) {
            const id = dataGrid.getSelectedRowKeys()[0];
            const url = `/Submittal/Tracking/CreateSubmittalRevision/${id}`;

            sendRequest(url, "", "POST", () => dataGrid.refresh());
        }
    }

    function createTransmittalSentTo() {
        const dataGrid = $("#SubmittalGrid").dxDataGrid("instance");

        if (dataGrid.getSelectedRowKeys().length) {
            const id = dataGrid.getSelectedRowKeys()[0];
            const url = `/Submittal/Tracking/SubmittalSentTo/${id}`;

            sendRequest(url, "", "POST", () => dataGrid.refresh());
        }
    }

    function createTransmittalForwardTo() {
        const dataGrid = $("#SubmittalGrid").dxDataGrid("instance");

        if (dataGrid.getSelectedRowKeys().length) {
            const id = dataGrid.getSelectedRowKeys()[0];
            const url = `/Submittal/Tracking/SubmittalForwardTo/${id}`;

            sendRequest(url, "", "POST", () => dataGrid.refresh());
        }

    }


    export function onGridSelectionChanged(e: any) {
        const dataGrid = e.component as DevExpress.ui.dxDataGrid;
        let dataId = dataGrid.getSelectedRowKeys()[0];
        let fileDesc = dataGrid.getSelectedRowsData()[0].submittalTitle;
        Areas.Attachment.updateAttachmentControls(dataId, "Submittal", fileDesc);

    }
}